import styled from 'styled-components';

export const ConfigBlock = styled.div`
    margin-bottom: 16px;

    > * {
        margin-bottom: 10px;
    }
`;
